import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import FastSecureImg from "../../images/fast-secure.svg"
import EssentialsPageStyle from "./essentials-page.module.scss"

const FastSecure = () => (
    <StaticQuery query={graphql`
        query FastSecure {
            contentfulTheEssentialsPage{
                essentialsReference{
                 sectionContent3{
                      subtitle{
                        subtitle
                      }
                      sectionParagraph{
                        json
                      }
                    }
                }
            }
        }
    `}
    render={data =>(
    <div className={EssentialsPageStyle.sectionDiv}>
        <Col xs={12}>
            <h3 className={EssentialsPageStyle.sectionTitle}>{data.contentfulTheEssentialsPage.essentialsReference.sectionContent3.subtitle.subtitle}</h3>
            <div className={EssentialsPageStyle.sectionDescription}>
                {documentToReactComponents(data.contentfulTheEssentialsPage.essentialsReference.sectionContent3.sectionParagraph.json)}
            </div>
            <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                <FastSecureImg className={EssentialsPageStyle.fastSecureImg} />
            </ScrollAnimation>
        </Col>
    </div>
    )}
    />
)

export default FastSecure